exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".PatientConsentForMedicalRecordsExchange--1gAoFWt2sbWQkN9GR3ekrR {\n  display: flex;\n  height: 16px;\n  padding: 20px;\n  font-size: 15px;\n  line-height: 15px;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;\n}\n", ""]);

// exports
exports.locals = {
	"error": "PatientConsentForMedicalRecordsExchange--1gAoFWt2sbWQkN9GR3ekrR",
	"error": "PatientConsentForMedicalRecordsExchange--1gAoFWt2sbWQkN9GR3ekrR"
};